const ROLES = ["Inventor", "Designer", "Developer", "CAD Wrangler", "Robot Builder", "Person Responsible"];

const PERSONNEL = [
    { k: "EMPLOYEE", v: "001 (TIM)", cls: "text-slate-900" },
    { k: "CLEARANCE", v: "OWNER", cls: "text-cyan-600" },
    { k: "DEPARTMENT", v: "ALL OF THEM", cls: "text-emerald-600" },
    { k: "SUPERVISOR", v: "ALSO TIM", cls: "text-slate-600" },
    { k: "PERFORMANCE REVIEW", v: "SELF-ASSESSMENT PENDING", cls: "text-amber-600" },
];

const ORG_CHART = `TIM
|
|-- ROBOTICS DIVISION ................ (TIM)
|-- SOFTWARE DIVISION ................ (TIM)
|-- ARTIFICIAL INTELLIGENCE DIVISION . (TIM)
|-- DESIGN DEPARTMENT ................ (TIM)
|-- PROTOTYPING ...................... (TIM)
|-- IT SUPPORT ....................... (TIM)
|-- PROCUREMENT ...................... (TIM)
\`-- MANAGEMENT ....................... (TIM)`;

export default function AboutSection() {
    return (
        <section id="structure" className="py-20 border-b border-subtle bg-[#e9edf1]" data-testid="about-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
                    <div className="lg:col-span-6 space-y-6">
                        <span className="font-mono text-xs text-cyan-600 tracking-widest uppercase">
                            // Personnel Archive
                        </span>
                        <h2 className="font-display text-3xl sm:text-4xl font-bold text-slate-900">
                            THE ENTIRE R&amp;D DEPARTMENT
                        </h2>
                        <div className="flex flex-wrap gap-2 font-mono text-[11px]">
                            {ROLES.map((r) => (
                                <span
                                    key={r}
                                    className="px-2.5 py-1 rounded border border-subtle bg-white text-slate-600"
                                >
                                    {r.toUpperCase()}
                                </span>
                            ))}
                        </div>
                        <p className="text-slate-600 leading-relaxed">
                            Timbotic is an independent experimental workshop in Brisbane, Australia. It exists to
                            build robots, software, strange interfaces and whatever seemed like a good idea at
                            approximately 11:47 PM.
                        </p>

                        <div className="p-5 rounded-lg bg-white border border-subtle font-mono text-xs space-y-2">
                            <div className="text-cyan-600 font-bold border-b border-slate-200 pb-2">
                                TIMBOTIC PERSONNEL RECORD
                            </div>
                            {PERSONNEL.map((p) => (
                                <div key={p.k} className="flex justify-between gap-4 text-slate-600">
                                    <span>
                                        {p.k}
                                        <span className="text-slate-700"> {".".repeat(Math.max(2, 20 - p.k.length))}</span>
                                    </span>
                                    <span className={p.cls}>{p.v}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="lg:col-span-6">
                        <div
                            data-testid="org-chart"
                            className="p-6 rounded-lg bg-white border border-subtle font-mono text-xs"
                        >
                            <div className="text-slate-500 pb-3 border-b border-slate-200 mb-4 flex justify-between">
                                <span className="text-cyan-600">CORPORATE ORGANISATIONAL CHART</span>
                                <span data-testid="org-headcount">
                                    HEADCOUNT: <span className="text-slate-900 font-bold">1</span>
                                </span>
                            </div>
                            <pre className="text-slate-600 leading-relaxed overflow-x-auto whitespace-pre font-mono">
                                {ORG_CHART}
                            </pre>
                            <div className="pt-3 border-t border-slate-200 mt-4 text-slate-500">
                                SPAN OF CONTROL: TOTAL // SUCCESSION PLAN: UNCLEAR
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
